module.exports = __webpack_public_path__ + "static/media/pattern-nav.cc9a3132.svg";